import React from 'react';
import aboutThumb from '../../../assets/images/frontdesk-bill.webp';

function ShowCase() {
    return (
        <>
            <section className="appie-about-area mb-50  pt-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div
                                className="appie-about-box wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="200ms"
                            >
                                <div className="row align-items-center">
                                    <div className="col-lg-5">
                                        <div className="about-thumb">
                                            <img
                                                loading="lazy"
                                                className="rounded"
                                                src={aboutThumb}
                                                alt="OTO POS Receipt"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-7">
                                        <div className="appie-about-content">
                                            <span>OTO Frontdesk</span>
                                            <h2 className="as-h3 title">
                                                A solution for hotels and lodging establishments
                                            </h2>
                                            <p>
                                                Powerful tools that can help you manage your hotel
                                                rooms, reservations, and bookings with ease and
                                                efficiency.
                                            </p>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="appie-about-service mt-30">
                                                    <div className="icon">
                                                        <i className="fal fa-check" />
                                                    </div>
                                                    <h3 className="as-h4 title">
                                                        Customizable bills
                                                    </h3>
                                                    <p>
                                                        OTO offers a customizable bill layout that
                                                        allows businesses to enhance their brand
                                                        image, increase customer recognition
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="appie-about-service mt-30">
                                                    <div className="icon">
                                                        <i className="fal fa-check" />
                                                    </div>
                                                    <h3 className="as-h4 title">
                                                        Customizable Payment Methods
                                                    </h3>
                                                    <p>
                                                        Whether you prefer to accept cash, credit
                                                        cards, mobile payments, or any combination
                                                        thereof, our app has you covered
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="appie-about-service mt-30">
                                                    <div className="icon">
                                                        <i className="fal fa-check" />
                                                    </div>
                                                    <h3 className="as-h4 title">Custom pricing</h3>
                                                    <p>
                                                        Set custom pricing for different room types,
                                                        seasons, and promotions, giving you the
                                                        flexibility to adjust your prices to meet
                                                        demand.
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="appie-about-service mt-30">
                                                    <div className="icon">
                                                        <i className="fal fa-check" />
                                                    </div>
                                                    <h3 className="as-h4 title">
                                                        Integration with other systems
                                                    </h3>
                                                    <p>
                                                        Integrates with our point of sale (POS)
                                                        system. To help you streamline operations
                                                        and reduce manual data entry.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default ShowCase;
